import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import isEmpty from 'lodash/isEmpty';
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import Body from 'chameleon/ui-stack/ui/page/body';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import useFetchTeacherAssignments from 'chameleon/ui-stack/hooks/use-assignments-fetch/teacher';
import BulkToolbar from 'legacy-src/components/TeacherOrganize/components/BulkToolbar';
import TeacherAssignmentsTable from 'chameleon/ui-stack/ui/assessments';
import HorizontalTabs from 'chameleon/ui-stack/ui/base/tabs/horizontal-tabs';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import HorizontalTabsContainer from 'chameleon/ui-stack/ui/page/horizontal-tabs-container';
import UploadAnswerSheet from 'chameleon/ui-stack/ui/assessments/upload-answer-sheet';
import {
  isFilterVisible,
  PPC,
  TYPE_FILTERS,
} from 'chameleon-src/components/assignments/constants';
import {
  findSubjectByMasterSubjectId,
  shouldShowAttestationDialog,
} from 'legacy-src/components/learnosity/utils/helpers';
import AttestationDialog from 'legacy-src/components/homepage/AttestationDialog';
import {
  STATUS,
  ASSESSMENTS_DEFAULT_STATUS,
  ASSIGNMENTS_DEFAULT_STATUS,
  ASSESSMENT_STATUSES,
} from 'chameleon-src/constants/assessmentStatus';
import Filters, {
  useGetFilterOptions,
} from 'chameleon/ui-stack/ui/assessments/filters';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';
import useLocalStorage from 'chameleon/ui-stack/ui/base/hooks/use-local-storage';
import {
  ASSIGNMENTS_QUIZZES_EMPTY_TABLE_MESSAGE,
  ASSIGNMENTS_DEFAULT_EMPTY_TABLE_MESSAGE,
  ASSIGNMENTS_LABEL_FILTER_EMPTY_TABLE_MESSAGE,
} from './utils/const';

const TeacherAssignmentsContainer = (props) => {
  const {
    router,
    userData,
    assignmentStatues = [],
    userSubjects,
    showAttestationFlag,
    me,
    studentPracticeProblems,
    disablePpcAutoAssignFlag,
    tablePageSizeFF,
    pdfAssignmentsFF,
    noReloadUpdateLabelFF,
    afamEp26FullLaunchP1FF,
    classes,
  } = props || {};

  const [data, setData] = useState();
  const [hasPaperscore, setHasPaperscore] = useState(false);
  const [options, setOptions] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isAttestationShown, setIsAttestationShown] = useState(false);
  const [reportsData, setReportsData] = useState(null);
  const [cachedDates, setCachedDates] = useState(null);
  const [isReorderInProgress, setIsReorderInProgress] = useState(false);

  const {
    goTo,
    pushParamsToHistory,
    queryParams,
    hasLabelsParams,
    location,
    params,
  } = useNavigation({
    router,
  });
  const {
    status,
    type: resourceType = '',
    labels: labelFilters = '',
    refreshAssignments,
    labels: organizeLabelFilter = '',
    section: sections,
    searchTerm,
  } = queryParams || {};
  const { subject } = params;
  const [getTeacherAssignments, learnositySignedRequest] =
    useFetchTeacherAssignments();
  const { filterOptions } = useGetFilterOptions(queryParams);

  const subjectInfo = findSubjectByMasterSubjectId(userSubjects, subject);

  const { chosenEducationPeriodCode: educationalPeriod, isStudent } = userData;

  const { initId: userId } = me || {};

  const [saveItemToLocalStorage] = useLocalStorage({
    key: `sortBy`,
    itemKey: `${userId}-${subject}`,
    index: 1,
  });

  const loadAssignments = () => {
    const fetchProps = {
      subject,
      status,
      organizeLabelFilter,
      resourceType,
      setData,
      setOptions,
      setLoading,
      sections,
      setHasPaperscore,
      setCachedDates,
      setReportsData,
      educationalPeriod,
      searchTerm,
      isLoading,
      isReorderInProgress,
    };
    getTeacherAssignments({ ...fetchProps });
  };

  useEffect(
    () => () => {
      // when we switch to another page
      saveItemToLocalStorage(JSON.stringify([]));
    },
    [],
  );

  useEffect(() => {
    const isAllResources = status === STATUS.ALL_RESOURCES;
    const shouldGetAssignments =
      !isAllResources || (isAllResources && !isEmpty(resourceType));
    if (shouldGetAssignments) {
      loadAssignments();
    }
  }, [status, resourceType, sections, organizeLabelFilter, searchTerm]);
  // without the join react seems to reload indefinitely, maybe it treats arrays at different mem addresses as different
  // values.

  useEffect(() => {
    /**
     * We have loadAssignments pending and the reorder is no longer in progress.
     *
     * The isLoading also ensures we don't reload the table everytime we reorder.
     */
    if (isLoading && !isReorderInProgress) {
      loadAssignments();
    }
  }, [isReorderInProgress]);

  useEffect(() => {
    if (String(refreshAssignments) === '1') {
      pushParamsToHistory({}, null, ['refreshAssignments']);
      loadAssignments();
    }
  }, [refreshAssignments]);

  const typeFilters = TYPE_FILTERS(
    studentPracticeProblems,
    pdfAssignmentsFF,
    status?.split(',')?.find((s) => ASSESSMENT_STATUSES.includes(s)),
    subjectInfo?.type,
  );

  // Whenever the `type` param is empty
  // Use the default one and replace the current URL
  useEffect(() => {
    if (isEmpty(resourceType)) {
      const type = typeFilters.filter((filter) =>
        isFilterVisible(
          subject,
          status,
          filter,
          isStudent,
          afamEp26FullLaunchP1FF,
        ),
      )[0].value;

      goTo({
        pathname: location.pathname,
        query: { ...queryParams, type },
        state: location?.state || null,
      });
    }
  }, [location]);

  const noDataText = (
    resourceFilter = '',
    statusFilter = 'assigned',
    labelsFilter = '',
  ) => {
    if (labelsFilter) {
      return (
        <span>
          <span
            dangerouslySetInnerHTML={{
              __html: ASSIGNMENTS_LABEL_FILTER_EMPTY_TABLE_MESSAGE,
            }}
          />
        </span>
      );
    }
    const { value: resource } =
      typeFilters.find(({ value }) => value === resourceFilter) || {};
    const { status } =
      assignmentStatues.find(
        ({ status: assignmentStatus, aliases }) =>
          assignmentStatus === statusFilter || aliases.includes(statusFilter),
      ) || {};
    const noResourcesMessage =
      resource === 'teacher-authored'
        ? ASSIGNMENTS_QUIZZES_EMPTY_TABLE_MESSAGE
        : ASSIGNMENTS_DEFAULT_EMPTY_TABLE_MESSAGE;

    if (
      resource === PPC &&
      status === STATUS.ALL_RESOURCES &&
      !disablePpcAutoAssignFlag
    ) {
      return (
        <div>
          Progress Checks have been pre-assigned to your classes. Your students
          see Progress Checks as locked until you unlock them. You can unlock
          Progress Checks for your students at&nbsp;
          <Link to={`/${subject}/assignments?status=all-assigned&type=ppc`}>
            All Assigned – Progress Checks
          </Link>
          .
        </div>
      );
    }

    if (status === STATUS.ALL_RESOURCES) {
      return <span>No resources to display.</span>;
    }

    return (
      <span>
        <span dangerouslySetInnerHTML={{ __html: noResourcesMessage }} />
        <Link
          to={`/${subject}/assignments?status=${STATUS.ALL_RESOURCES}&type=${resource}`}
        >
          All Resources
        </Link>{' '}
        page.
      </span>
    );
  };

  const onLearnosityDataReady = (learnosityReportsData) => {
    setReportsData(learnosityReportsData);
  };

  const paramsToOmit = [
    'apd',
    'quizId',
    'action',
    'quizSummaryId',
    'shareAssessmentInviteItemId',
    'assessmentTitle',
  ];

  const onFilterChange = useCallback(
    (filters) => {
      const _status = filters?.status;
      if (_status) {
        pushParamsToHistory(
          {
            status: _status.toString(),
          },
          null,
          paramsToOmit,
        );
      } else {
        pushParamsToHistory(
          {
            //type can be assessments or assignments
            status:
              filterOptions.type === 'assessments'
                ? ASSESSMENTS_DEFAULT_STATUS
                : ASSIGNMENTS_DEFAULT_STATUS,
          },
          null,
          paramsToOmit,
        );
      }
    },
    [queryParams, filterOptions],
  );

  const onSectionFilterChange = useCallback(
    (filters) => {
      const selectedSection = filters?.section;
      if (selectedSection) {
        pushParamsToHistory(
          {
            section: selectedSection.toString(),
          },
          null,
          paramsToOmit,
        );
      } else {
        pushParamsToHistory(
          {
            section: null,
          },
          null,
          paramsToOmit,
        );
      }
    },
    [queryParams, filterOptions],
  );

  const isCorrectType = (data) => {
    const dataWithNoFinalExam = data.filter((d) => !d.is_final_exam);
    if (dataWithNoFinalExam.length === 0 || resourceType === '') {
      return true;
    }
    return dataWithNoFinalExam?.[0]?.type === resourceType;
  };

  const isFiltersEnabled =
    (queryParams?.type === resourceTypes.pdf && pdfAssignmentsFF) ||
    queryParams?.type !== resourceTypes.pdf;

  const onBulkLabelUpdate = ({ resources, labelIds }) => {
    let updatedData = data.map((resource) => {
      const resourceId = Number.parseInt(resource.id, 10);
      const videoOrPdfMatch = (resources[resource.type] || {})[resourceId];
      const assessmentMatch =
        resources[resourceTypes.item][resourceId] && !videoOrPdfMatch;
      if (videoOrPdfMatch || assessmentMatch) {
        resource.labels = Array.from(
          new Set([
            ...resource.labels,
            ...labelIds.map((labelId) => Number.parseInt(labelId, 10)),
          ]),
        );
      }
      return resource;
    });
    setData(updatedData);
  };

  return (
    <Fragment>
      <BulkToolbar
        data={data}
        pageSize={tablePageSizeFF || 30}
        page={parseInt(queryParams.page, 10) || 0}
        masterSubject={subject}
        onBulkLabelUpdate={
          noReloadUpdateLabelFF ? onBulkLabelUpdate : loadAssignments
        }
        disableBulkCheckbox={resourceType === resourceTypes.pdf}
      />
      {status === STATUS.ALL_RESOURCES &&
        shouldShowAttestationDialog(
          showAttestationFlag,
          userSubjects,
          me,
          isAttestationShown,
          subject,
        ) && (
          <AttestationDialog
            subjectId={subjectInfo.initId}
            onClose={setIsAttestationShown}
          />
        )}
      <HorizontalTabsContainer
        leftContainer={
          <HorizontalTabs
            tabs={typeFilters
              .filter((filter) =>
                isFilterVisible(
                  Number(subject),
                  status,
                  filter,
                  isStudent,
                  afamEp26FullLaunchP1FF,
                ),
              )
              .map((filter) => {
                const isActive = Boolean(
                  filter.value === resourceType ||
                    (filter?.values?.length &&
                      !filter.values.includes(resourceType)),
                );

                return {
                  name: filter.name,
                  onClick: () =>
                    pushParamsToHistory(
                      { type: filter.value, ...(filter?.params || {}) },
                      location.pathname,
                      ['page'],
                    ),
                  isActive,
                  otherProps: {
                    'data-value': filter.value,
                    ...(filter.trackingId && {
                      'data-tracking-id': filter.trackingId,
                    }),
                  },
                };
              })}
            accessibility={{
              'aria-label': 'Assignment tabs',
            }}
          />
        }
        rightContainer={
          <Fragment>{hasPaperscore && <UploadAnswerSheet />}</Fragment>
        }
      />
      <Body>
        {!hasLabelsParams && isFiltersEnabled && (
          <Filters
            queryParams={queryParams}
            title="Filter by"
            statuses={filterOptions}
            onSectionFilterChange={onSectionFilterChange}
            onFilterChange={onFilterChange}
            sections={classes}
            subject={subject}
            router={router}
            educationPeriod={educationalPeriod}
          />
        )}
        {!isLoading &&
        data &&
        isCorrectType(data) &&
        (!learnositySignedRequest ||
          (learnositySignedRequest && reportsData)) ? (
          <TeacherAssignmentsTable
            data={data}
            noDataText={noDataText(resourceType, status, labelFilters)}
            learnositySignedRequest={learnositySignedRequest}
            options={options}
            userData={userData}
            loadAssignments={loadAssignments}
            reportsData={reportsData}
            cachedDates={cachedDates}
            setCachedDates={setCachedDates}
            setIsReorderInProgress={setIsReorderInProgress}
          />
        ) : (
          <Fragment>
            <LoadingSpinner />
            {learnositySignedRequest && !reportsData && (
              <LearnosityProvider
                apiType="reports"
                initOptions={JSON.parse(learnositySignedRequest)}
                dataListener={(lrnData) => onLearnosityDataReady(lrnData)}
              />
            )}
          </Fragment>
        )}
      </Body>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    featureFlag: {
      show_attestation_confirmation_dialog: showAttestationFlag,
      student_practice_problems,
      disable_ppc_auto_assign: disablePpcAutoAssignFlag,
      my_assignment_page_size: tablePageSizeFF,
      my_assignments_pdf: pdfAssignmentsFF,
      spp_filter_by_subject,
      spp_filter_by_school,
      no_reload_update_label: noReloadUpdateLabelFF,
      afam_ep26_full_launch_p1: afamEp26FullLaunchP1FF,
    },
    userData,
    userSubjects,
    subject,
  } = state;
  return {
    me: userData.me,
    showAttestationFlag,
    userSubjects,
    studentPracticeProblems:
      student_practice_problems ||
      (spp_filter_by_subject && spp_filter_by_school),
    disablePpcAutoAssignFlag,
    tablePageSizeFF,
    pdfAssignmentsFF,
    noReloadUpdateLabelFF,
    afamEp26FullLaunchP1FF,
    classes: subject.data.classes || [],
  };
};

export default compose(connect(mapStateToProps, {}))(
  TeacherAssignmentsContainer,
);
